/**
 * MKS-334 — the Receivables page's data. One request to
 * `GET /api/invoices/receivables`, already aggregated per client, bucketed and
 * sorted server-side, with each client's unpaid invoices nested so expanding a
 * row costs nothing.
 *
 * The filters are part of the query key, so switching between "overdue only"
 * and "all unpaid" is a cached swap rather than a re-fetch of the same view.
 */
import { useQuery } from '@tanstack/react-query';
import { getReceivables, type ReceivablesReport } from '../services/api/invoices';

export type {
  ReceivablesReport,
  ReceivablesClientRow,
  ReceivablesInvoiceRow,
  ReceivablesAmounts,
  ReceivablesDso,
  AgingBucketAmounts,
} from '../services/api/invoices';

export interface ReceivablesFilters {
  client?: string;
  overdueOnly?: boolean;
}

export function useReceivables(filters: ReceivablesFilters, enabled = true) {
  return useQuery<ReceivablesReport>({
    queryKey: ['invoices', 'receivables', filters.client ?? null, filters.overdueOnly !== false],
    queryFn: () => getReceivables(filters),
    enabled,
    staleTime: 60_000,
  });
}
